import { Cog6ToothIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

export default function MaintenanceMode() {
  const { t } = useTranslation();
  return (
    <main className='grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8'>
      <div className='text-center'>
        <Cog6ToothIcon className='mx-auto h-20 w-20 text-primary' />
        <h1 className='mt-4 text-3xl font-bold tracking-tight text-black sm:text-5xl'>{t('maintenanceMode.title')}</h1>
        <p className='mt-6 text-base leading-7 text-secondary w-[550px] mx-auto'>{t('maintenanceMode.subtitle')}</p>
        <div className='mt-10 flex items-center justify-center'>
          <a
            href='https://wa.me/966550132719'
            target='_blank'
            rel='noopener noreferrer'
            className='rounded-md bg-primary px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600'
          >
            {t('shared.contactSupport')}
          </a>
        </div>
      </div>
    </main>
  );
}
